import React from "react";
import styled from "styled-components";


export default styled.span`
    flex: 0 0 auto;
    text-align: center;
    height: 61px;
    color: rgb(136 136 136);
    font-weight: 700;
    opacity: ${(props) => (props.hidden ? "0" : "1")};
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 15px;

    i {
        margin-right: 10px;
    }
`;
